export default __webpack_public_path__ + "static/luzean-sankey-b92980edda377242aecb931fd813d9df.webp";